// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2l9xU","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__m0Otx"};